<template>
    <div class="customers-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />
        
        <customer-revenue v-show="selectedItem === 'customerRevenue'" @finishedLoading="updateCount('customerRevenue', $event)" />
        <customer-type-revenue v-show="selectedItem === 'customerTypeRevenue'" @finishedLoading="updateCount('customerTypeRevenue', $event)" />
        <customer-revenue-grouped v-show="selectedItem === 'customerRevenueGrouped'" />
        
    </div>
</template>

<script>

export default {
    data () {
        return {
            selectedItem: 'customerTypeRevenue',
            counts: {
                customerRevenue: null,
                customerTypeRevenue: null
                // customerRevenueGrouped: null
            },
            switchItems: [
                {
                    name: 'Hvilke kundetyper tjener vi penge på?',
                    slug: 'customerTypeRevenue'
                },
                {
                    name: 'Hvilke konkrete kunder tjener vi penge på?',
                    slug: 'customerRevenue'
                },
                {
                    name: 'Hvordan er kunderne fordelt på omsætning?',
                    slug: 'customerRevenueGrouped'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    mounted () {
        this.$store.state.view = 'learning'
    },
    components: {
        'customer-revenue': require('./operations/customerRevenue.vue'),
        'customer-type-revenue': require('./operations/customerTypeRevenue.vue'),
        'customer-revenue-grouped': require('./operations/customerRevenueGrouped.vue')
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?5b46b5d7